/**
 * Add a deals hub page to help retailers discover promotions and flash sales
 * https:www.notion.so/faire/Improved-benefits-Discovery-of-Deals-aa7ffc6f79e340f2a02d3b725b022c16
 */ export var DEALS_HUB_240826 = 'DEALS_HUB_240826';
